import { ReactNode } from "react";

import { Container } from "@mui/material";

import { Background } from "@baseComponents/Background";
import Footer from "@components/footer";
import { Menu } from "@components/menu";
import { PageMetadata, PageMetadataProps } from "@components/PageMetadata";

interface BlogLayoutProps extends PageMetadataProps {
  children?: ReactNode;
}

function BlogLayoutBody({ children, title, description }: BlogLayoutProps) {
  return (
    <>
      <PageMetadata title={title} description={description} />

      <Background />

      <Menu />

      <Container maxWidth="desktopXl" className="p-0">
        {children}
      </Container>

      <Footer />
    </>
  );
}

export const BlogLayout = ({ children, ...rest }: BlogLayoutProps) => {
  return <BlogLayoutBody {...rest}>{children}</BlogLayoutBody>;
};
